import { render, staticRenderFns } from "./SkuSpecialTitle.vue?vue&type=template&id=6ba8548b&scoped=true&"
import script from "./SkuSpecialTitle.vue?vue&type=script&lang=ts&"
export * from "./SkuSpecialTitle.vue?vue&type=script&lang=ts&"
import style0 from "./SkuSpecialTitle.vue?vue&type=style&index=0&id=6ba8548b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba8548b",
  null
  
)

export default component.exports